'use strict';

module.exports = function emoji_html(tokens, idx /*, options, env */) {
  return tokens[idx].content;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/markdown-it-emoji/lib/render.js
// module id = 2065
// module chunks = 6